export const GET_MEMBERS = 'GET_MEMBERS';
export const GET_ALL_MEMBERS = 'GET_ALL_MEMBERS';

export const NEW_EMPLOYEE = 'NEW_EMPLOYEE';
export const ALL_DEPT = 'ALL_DEPT';
export const UPDATE_ALL_DEPT = 'UPDATE_ALL_DEPT';
export const DELETE_MEMBER = 'DELETE_MEMBER';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
